


































import { Component, Vue, Prop } from 'vue-property-decorator';

import VueError from '@/components/VueError.vue';

import moment from 'moment';

import tippy from 'tippy.js';
import { LoraWanUpdate} from '@/types/core';

@Component({
  components:{
    VueError
  }
})
export default class LoraWanUpdateView extends Vue {

  error:string = '';
  @Prop({ default: 0,  type: Number}) messageTs!: number;
  @Prop({ default: () => {},  type: Object}) loraWanUpdate!: LoraWanUpdate;
  @Prop({ default: false,  type: Boolean}) showAll!: boolean;
  @Prop({ default: false, type: Boolean}) outOfOrderUplinkCnt!: boolean;
  async mounted() {
    // nothing yet

    tippy('[data-tippy-content]');
  }

  get spClasses() {

    return { 
      warning: this.loraWanUpdate.spFact === 11, 
      danger: this.loraWanUpdate.spFact === 12, 
    }
  }

  get snrClasses() {

    return {
      warning: this.loraWanUpdate.snr < 0 && this.loraWanUpdate.snr > -5, 
      danger: this.loraWanUpdate.snr < -5, 
    }
  }

  get rssiClasses() {

    return {
      warning: Math.abs(this.loraWanUpdate.rssi) > 100 && Math.abs(this.loraWanUpdate.rssi) < 115, 
      danger: Math.abs(this.loraWanUpdate.rssi) > 115,
    }
  }

  get delaySec() {
    return Math.round((this.messageTs - this.loraWanUpdate.lrrTs)/1000);
  }

}

